import type { UserResource } from '@/api/gateway/legacy-api/resources/UserResource';
import { gateway } from '@/api/gateway';

export function getMyself() {
    return gateway.get<UserResource>('/legacy-api/v1/myself').then((response) => response.data);
}
